import { Link } from 'react-router-dom'
import type { FocusEvent, MouseEvent, ReactNode } from 'react'
import { createPortal } from 'react-dom'

export interface CollapsedFlyoutProps {
    title: string
    link?: string
    rect: DOMRect
    children?: ReactNode
    onLeave?: (event: MouseEvent<HTMLDivElement> | FocusEvent<HTMLDivElement>) => void
    innerRef?: React.Ref<HTMLDivElement>
}

const CollapsedFlyout = ({ title, link, rect, children, onLeave, innerRef }: CollapsedFlyoutProps) => {
    const flyout = (
        <div
            ref={innerRef}
            className='fixed z-[100] flex flex-col items-start gap-3 pl-4'
            role='dialog'
            aria-label={title}
            style={{ top: rect.top, left: rect.right }}
            onMouseLeave={onLeave}
            onBlur={onLeave}
            data-sidebar-flyout
            tabIndex={-1}
        >
            <div className='relative translate-y-[12px]'>
                {link ? (
                    <Link
                        to={link}
                        className='block rounded-xl bg-[#481C4F] px-4 py-2 text-sm font-medium text-white shadow-[0px_10px_20px_rgba(72,28,79,0.25)] hover:bg-[#63316B] transition-colors'
                    >
                        {title}
                    </Link>
                ) : (
                    <div className='rounded-xl bg-[#481C4F] px-4 py-2 text-sm font-medium text-white shadow-[0px_10px_20px_rgba(72,28,79,0.25)]'>
                        {title}
                    </div>
                )}
                <span className='absolute -left-2 top-1/2 h-4 w-4 -translate-y-1/2 rotate-45 rounded-[2px] bg-[#481C4F]' />
            </div>
            {children ? (
                <div className='min-w-[220px] rounded-3xl border border-[#E4DEE5] bg-white p-3 shadow-[0px_24px_40px_rgba(72,28,79,0.12)]'>
                    {children}
                </div>
            ) : null}
        </div>
    )

    return typeof document !== 'undefined' ? createPortal(flyout, document.body) : flyout
}

export default CollapsedFlyout
